<script setup>
import { onMounted, computed, ref } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useRequestsStore } from "./stores/storeRequests";
import { useScrollStore } from "@/stores/storeScroll";
import { sectionsObserver } from "@/utils/useObserver";
import { useRoute, useRouter } from "vue-router";
import cookies from "browser-cookies";
import { useModals } from "./utils/useModals";
import TheHeader from "@/components/sections/TheHeader.vue";
import TheFooter from "@/components/sections/TheFooter.vue";
import TheModals from "@/components/blocks/TheModals.vue";
import TheStubPage from "@/pages/TheStubPage.vue";
import BaseCookies from "@/components/blocks/BaseCookies.vue";
import { register } from "swiper/element/bundle";

register();

const storeSettings = useSettingsStore();
const storeScroll = useScrollStore();
const storeRequests = useRequestsStore();
const { observer } = sectionsObserver();
const route = useRoute();
const { openModal, closeModal } = useModals();

const isStubPage = false;
const ageVerified = ref(false)

const addBlur = computed(() => modalId.value === 'ageNotVerification' || modalId.value === 'ageVerification' ? '--not-blur' : '');

const ageCheck = () => {
	cookies.set("cookieAgeVerification", "true", { expires: 182 });
	ageVerified.value = true;
	closeModal();
};

onMounted(async () => {
	await storeSettings.mainSettings();

	if (storeRequests.isAuthenticated) await storeRequests.userInfo();

	if (!isStubPage) {
		const params = new URLSearchParams(window.location.search);
		if (params.toString()) {
			localStorage.setItem("registration_params", params.toString());
		}
	}

	const popapPassword = route.query.popapPassword;

	if (popapPassword) {
		openModal("modalPassword");
	}

	const cookieAgeVerification = cookies.get("cookieAgeVerification");	

	if (!cookieAgeVerification) {
		openModal("ageVerification");
	} else {
		ageVerified.value = true
	}
	
});
</script>

<template>
	<div v-if="!isStubPage" :class="['wrapper', { '--not-blur': ageVerified }]" ref="mainScreen">
		<TheHeader />
		<main :class="['main']">
			<RouterView />
		</main>
		<TheFooter />
	</div>
	<TheStubPage v-else />
	<TheModals :age-verified @age-check="ageCheck" v-if="!isStubPage" />
	<BaseCookies v-if="!isStubPage" />
</template>

<style type="scss" scoped></style>
